<template>
<div class="chapter">
<div class="inner_page">
<section>
<figure class="custom-block-58f018ca1317b atavist-shared atavist-block atavist-block-align-center"><img alt="The Palphramonds Family Tree" height="600" src="images/scale1920x1200palphramonds-1531735640-50.jpg" style=" width:600px; height:600px;" width="600"/> <figcaption><span class="caption-body">Characters who never appear directly in the narrative are in <i style="">italics</i>. Those who might possess the estate if Jeoffrey Huffam’s suppressed codicil were in force appear in <b style="">bold</b> typeface. Those who might possess it if his purloined will were laid before the court are in <b style="">BOLD CAPITALS</b>.</span></figcaption></figure>
<p class="firstInSection"><br/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?2c09c9aa